import { render, staticRenderFns } from "./Eoh.vue?vue&type=template&id=20bc0f06&scoped=true&"
import script from "./Eoh.vue?vue&type=script&lang=js&"
export * from "./Eoh.vue?vue&type=script&lang=js&"
import style0 from "./Eoh.vue?vue&type=style&index=0&id=20bc0f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc0f06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
